export function getIsCalendarGridWeekBlockSecondaryLabelHidden({
  isCompact,
  isSecondaryLabelPinned,
}) {
  return Boolean(isCompact) && !isSecondaryLabelPinned
}

export function getIsCalendarGridWeekBlockTooltipDisabled({
  hint,
  isHintDetailed,
}) {
  return !isHintDetailed && !hint
}
